import { Stack } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { CreateReportGrowthRatesFormData } from '../../models/reports/input';
import { GrowthRates as GrowthRatesFormData, useReportStore } from '../../providers/ReportProvider';
import { CardBody } from '../Card';
import { NumberFormControl } from '../Form';
import { Section } from '../PropertyInformation';

export function GrowthRates() {
  const { setValue } = useFormContext<CreateReportGrowthRatesFormData>();

  const { growthRates } = useReportStore();

  useEffect(() => {
    if (growthRates) {
      Object.keys(growthRates).forEach((key) =>
        setValue(key as keyof GrowthRatesFormData, growthRates[key as keyof GrowthRatesFormData])
      );
    }
  }, [setValue, growthRates]);

  return (
    <Section>
      <CardBody>
        <div className="flex flex-row gap-x-4">
          <Stack className="basis-1/3">
            <NumberFormControl
              name="appreciation"
              label="Appreciation"
              type="percent"
              precision={2}
              defaultValue={0}
            />
          </Stack>
          <Stack className="basis-1/3">
            <NumberFormControl
              name="revenueGrowthRate"
              label="Revenue Growth Rate"
              type="percent"
              precision={2}
              defaultValue={0}
            />
          </Stack>
          <Stack className="basis-1/3">
            <NumberFormControl
              name="expenseGrowthRate"
              label="Expense Growth Rate"
              type="percent"
              precision={2}
              defaultValue={0}
            />
          </Stack>
        </div>
      </CardBody>
    </Section>
  );
}

export default GrowthRates;
